import { Action } from "redux";
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  LOGOUT,
  LOGOUT_FAILD,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  UPDATE_FORM_SIGNUP,
  UPDATE_IDLE_TIME_CLIENT,
  UPDATE_TIME_RESUME_CLIENT,
  RESET_LOGIN,
  EXPIRE_TOKEN_CLIENT,
  UPDATE_INFO_USER,
  UPDATE_DATA_FORM_AUTH,
  FETCH_ME_DATA,
  FETCH_ME_DATA_SUCCESS,
  FETCH_ME_DATA_ERROR
} from "./types";
import { removeAxiosToken, setAxiosToken } from "core/networks/API";
import { config } from "core/config/app";
import { deviceStorage } from "core/utils/devicestorage";
import { ExpireTokenAction, LoginFailedAction, LoginRequestAction, LoginSuccessAction, ResetLoginAction } from "../interfaces/login";

export const loginRequest = (payload: any): LoginRequestAction => ({
  type: LOGIN_REQUEST,
  payload,
});

export const loginSuccess = (payload: any): LoginSuccessAction => ({
  type: LOGIN_SUCCESS,
  payload,
});

export const loginFailed = (payload: any): LoginFailedAction => ({
  type: LOGIN_FAILED,
  payload,
});

export const resetLogin = (payload: any): ResetLoginAction => ({
  type: RESET_LOGIN,
  payload,
})

export const expireToken = (payload: any): ExpireTokenAction => ({
  type: EXPIRE_TOKEN_CLIENT,
  payload,
})


export type FetchMeAction = Action<typeof FETCH_ME_DATA>
export const fetchMe = (): { type: string } => {
  const token = deviceStorage[
    localStorage.getItem("storage_driver") || "session"
  ].getItem(config.appPackage + "_X_TOKEN");
  if (token) setAxiosToken(token);
  return {
    type: FETCH_ME_DATA,
  };
};

export type FetchMeSuccessAction = Action<typeof FETCH_ME_DATA_SUCCESS>
export const fetchMeSucess = (payload: any): { payload: any; type: string } => {
  return {
    type: FETCH_ME_DATA_SUCCESS,
    payload,
  };
};

export const fetchMeError = (): { type: string } => {
  return {
    type: FETCH_ME_DATA_ERROR,
  };
};

export type logoutAction = Action<typeof LOGOUT>
export const logout = (): { type: string } => {
  removeAxiosToken();
  return {
    type: LOGOUT,
  };
};

export const updateFormSignUp = (
  payload: any
): { payload: any; type: string } => {
  return {
    type: UPDATE_FORM_SIGNUP,
    payload,
  };
};

export const logOutRequest = (payload?: any): { payload: any; type: string } => {
  return {
    type: LOGOUT_REQUEST,
    payload,
  };
};

export const logOutSuccess = (payload: any): { payload: any; type: string } => {
  // // //console.log('logOutSuccess action', payload);
  return {
    type: LOGOUT_SUCCESS,
    payload,
  };
};

export const logOutFaild = (payload: any): { payload: any; type: string } => {
  // // //console.log('logOutFaild action', payload);
  return {
    type: LOGOUT_FAILD,
    payload,
  };
};

export const updateIdleTime = (
  payload: any
): { payload: any; type: string } => {
  return {
    type: UPDATE_IDLE_TIME_CLIENT,
    payload,
  };
};
export const updateTimeResume = (
  payload: any
): { payload: any; type: string } => {
  return {
    type: UPDATE_TIME_RESUME_CLIENT,
    payload,
  };
};


export const updateInfoUser = (payload: any): { payload: any; type: string } => {
  // // //console.log('logOutFaild action', payload);
  return {
    type: UPDATE_INFO_USER,
    payload,
  };
};

export const updateFormSave = (
  payload: any
): { payload: any; type: string } => {
  return {
    type: UPDATE_DATA_FORM_AUTH,
    payload,
  };
};
